<template>
    <main id="main">
        <section id="services" :class="['pb-1', 'mb-1']">
            <div :class="['title-container']">
                <div>
                    <h3 :class="['title', 'text_color_drasam', 'mb-4']">
                        NUESTRO DIRECTORIO
                    </h3>
                </div>

                <div :class="['filters']">
                    <span :class="['filter', (currentFilter == '0')?'active bg_color_drasam':'']" @click="setFilter('0')">TODOS</span>
                    <span v-for="(val, key) in cargo" :key="key" :class="['filter', (currentFilter === val.id)?'active bg_color_drasam':'']" @click="setFilter(val.id)">
                        {{val.descripcion}}
                    </span>
                </div>
	        </div>

            <transition-group :class="['projects']" >
                <div :class="['project']" :key="key" v-for="(project, key) in directorio" v-if="project.filtro_directorio && (currentFilter === project.filtro_directorio || currentFilter === '0')">
                    <div :class="['project-image-wrapper']">
                        <img :class="['project-image']" :src="project.responsable.foto?project.responsable.path_file_foto:'img/profile.png'">
                        <div :class="['gradient-overlay']"></div>
                        <!--
                        <div :class="['circle']">
                            <span class="project-title">{{project.telefono_representante}}</span>
                        </div>
                        -->
                        <div :class="['p-3']">
                            <div style="font-size:11px;" :class="['fuenteBold', 'mb-3']">
                                <center>
                                    {{project.cargo_responsable.descripcion}} DE {{project.dependencia}}
                                </center>
                            </div>

                            <div style="font-size:12px;" :class="['', 'mb-2']">
                                <center>
                                    <i v-if="project.hb_today==true" class="fa fa-birthday-cake mr-2" style="color:pink;font-weight:bold; font-size:15px;" aria-hidden="true"></i>
                                    {{project.responsable.nombres}} {{project.responsable.apellido_paterno}} {{project.responsable.apellido_materno}}
                                </center>
                            </div>

                            <div style="font-size:12px;" :class="['fuenteBold', 'mb-3']">
                                <center>
                                    <i>{{project.responsable.email}}</i>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
            </transition-group>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';

    export default {
        name: 'Directorio',
        computed:{
            ...mapState(['loading','globales','empresa']),
        },
        data(){
            return{
                currentFilter:"0",
                cargo:[],
                directorio: [],
            }
        },
        created(){
           this.getCargos();
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Directorio || "+this.empresa.abreviatura;
            this.getDirectorio();
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            setFilter (filter) {
                this.currentFilter = filter;
            },
            getDirectorio(){
                this.setLoading(true);
                this.$http.get('webserviceserver/directorio').then((res)=>{
                    if(res.data.Directory)
                        this.directorio = res.data.Directory;
                    //console.log(this.directorio);
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
            getCargos(){
                this.setLoading(true);
                this.$http.get('webserviceserver/jefatura').then((res)=>{
                    if(res.data.Charge)
                        this.cargo = res.data.Charge;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
        }
    }
</script>

<style scoped>
    .title-container {
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
    }

    .title {
        font-family: 'Dawning of a New Day', cursive;
        font-size:30pt;
        font-weight:normal;
    }

    .project-title {
        font-size:12pt  
    }

    .filter {
        font-family:arial;
        padding: 15px 15px;
        cursor:pointer;
        border-radius: 6px;
        transition: all 0.35s;
    }

    .filter.active {
        box-shadow:0px 1px 3px 0px #00000026;
    }

    .filter:hover {
        background:lightgray;
    } 

    .projects {
        margin-bottom:50px;
        margin-top:25px;
        display:flex;
        flex-wrap:wrap;
        justify-content:center;
    }

    .projects-enter {
        transform: scale(0.5) translatey(-80px);
        opacity:0;
    }

    .projects-leave-to{
        transform: translatey(30px);
        opacity:0;
    }

    .projects-leave-active {
        position: absolute;
        z-index:-1;
    }

    .circle {
        text-align:center;
        position:absolute;
        bottom:-38px;
        left:40px;
        width:100px;
        height:100px;
        border-radius:50px;
        /*  border:1px solid black; */
        display:flex;
        box-shadow: 0px -4px 3px 0px #494d3257;
        justify-content:center;
        align-items:center;
        background-color:#fff;
        /*  box-shadow:0px -3px 3px #484848a6; */
    }

    .project {
        transition: all .35s ease-in-out;
        margin:10px;
        box-shadow:0px 2px 8px lightgrey;
        border-radius:3px;
        width:280px;
        height:370px;
        display:flex;
        flex-direction:column;
        align-items:center;
    }

    .project-image-wrapper {
        position:relative;
    }

    .gradient-overlay {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:240px;
        opacity:0.09;
        background: 
            linear-gradient(to bottom, rgba(0,210,247,0.65) 0%,rgba(0,210,247,0.64) 1%,rgba(0,0,0,0) 100%), 
            linear-gradient(to top, rgba(247,0,156,0.65) 0%,rgba(247,0,156,0.64) 1%,rgba(0,0,0,0) 100%);
        border-bottom-left-radius:10px;
        border-bottom-right-radius:10px;
        border-top-left-radius:3px;
        border-top-right-radius:3px;
    }

    .project-image {
        width:100%;
        height:240px;
        border-bottom-left-radius:5px;
        border-bottom-right-radius:5px;
        border-top-left-radius:3px;
        border-top-right-radius:3px;
    }
</style>